
export function getGetStaffMemberRoute() {
    return "admin/staff-member/get";
}